/* Golden Palace: nameplate personalization inside the quick-add drawer */
(function(){
if(window.GPQuickNP) return; window.GPQuickNP=true;
var FONTS={bold:{fam:"'Sail'"},classic:{fam:"'Arizonia'"},ornate:{fam:"'Pinyon Script'"},wire:{fam:"'Monsieur La Doulaise'"},cursive:{fam:"'Alex Brush'"},serif:{fam:"'Abril Fatface'"},sans:{fam:"'Anton'"},italic:{fam:"'Alfa Slab One'",skew:-12},hebrew:{fam:"'Frank Ruhl Libre'",w:900}};
function setup(b){
  if(b.dataset.ready) return; b.dataset.ready='1';
  var prod=b.closest('.quick-cart-product')||document;
  var form=prod.querySelector('form.product-card__add-to-cart--form'); if(!form) return;
  form.classList.add('gpqa-form');
  var ST=(b.dataset.style||'').trim().split(/\s+/), F=ST[0]||'bold', D=ST[1]||'none', X=ST[2]||'polish', L=ST[3]||'line';
  var FT=FONTS[F]||FONTS.bold, MAX=L==='initial'?1:(parseInt(b.dataset.max,10)||12), PROP=b.dataset.prop||'Name';
  var inp=b.querySelector('[data-gpqa-in]'), inp2=b.querySelector('[data-gpqa-in2]'), ok=b.querySelector('[data-gpqa-ok]'), err=b.querySelector('[data-gpqa-err]'), txt=b.querySelector('[data-gpqa-txt]'), cnt=b.querySelector('[data-gpqa-count]');
  var p1=form.querySelector('[data-gpqa-prop="1"]'), p2=form.querySelector('[data-gpqa-prop="2"]');
  inp.maxLength=MAX; inp2.maxLength=MAX;
  if(L==='initial'){ inp.placeholder='e.g. J'; b.querySelector('[data-gpqa-label]').textContent='Type the letter you want'; }
  if(L==='double'){ inp2.hidden=false; inp.placeholder='First name'; b.querySelector('[data-gpqa-label]').textContent='Type both names exactly as you want them'; }
  txt.style.fontFamily=FT.fam+',cursive'; if(FT.w) txt.style.fontWeight=FT.w; if(FT.skew) txt.style.fontStyle='italic';
  function clean(v){ var re=F==='hebrew'?/[^\u0590-\u05FFA-Za-z '\-]/g:/[^A-Za-z\u00C0-\u024F0-9 '\-&.#]/g; return (v||'').replace(re,'').replace(/\s{2,}/g,' ').replace(/^\s+/,'').slice(0,MAX); }
  function metal(){ var o=[].map.call(prod.querySelectorAll('input[type=radio]:checked, select'),function(e){return e.value;}).join(' ').toLowerCase(); var t=(b.dataset.title||'').toLowerCase(); var src=/silver|white|gold|yellow/.test(o)?o:t; return /silver|white/.test(src)?'silver':'gold'; }
  function sync(){
    var v=inp.value.trim(), v2=inp2.value.trim();
    p1.value=v; p1.disabled=!v;
    if(L==='double'){ p2.value=v2; p2.disabled=!v2; } else { p2.disabled=true; }
  }
  var PH=null;
  if(L==='line'&&window.GPPhoto){
    var sw=prod.querySelector('.quick-cart-drawer__media-swiper');
    PH=window.GPPhoto({F:F,D:D,X:X,FT:FT,input:inp,box:b,optRoot:prod,
      imgs:function(){ var i=sw&&sw.querySelector('.swiper-slide img'); return i?[i]:[]; },
      allImgs:function(){ return [].map.call(sw?sw.querySelectorAll('.swiper-slide img'):[],function(i){return i.dataset.gpOrig||i.currentSrc||i.src;}).filter(function(v,k,a){return v&&v.indexOf('blob:')!==0&&a.indexOf(v)===k;}); }});
    b.classList.add('is-photo');
  }
  function update(){
    cnt.textContent=inp.value.length;
    var v=inp.value.trim(), v2=inp2.value.trim();
    txt.textContent=(L==='double'&&v2)?(v||'Name')+' & '+v2:(v||(L==='initial'?'J':'Jessica'));
    txt.className='gpqa__txt gpqa__txt--'+metal();
    sync(); if(PH) PH.update();
    if(v){ try{ sessionStorage.setItem('gp_nameplate_name',v); }catch(e){} }
    var s=prod.querySelector('.quick-cart-drawer__media-swiper'); if(s&&s.swiper&&v) s.swiper.slideTo(0);
  }
  [inp,inp2].forEach(function(el){ el.addEventListener('input',function(){ var c=clean(el.value); if(c!==el.value) el.value=c; ok.checked=false; err.hidden=true; b.classList.remove('is-error'); update(); }); });
  ok.addEventListener('change',function(){ if(ok.checked){ err.hidden=true; b.classList.remove('is-error'); } });
  prod.addEventListener('change',function(e){ if(!b.contains(e.target)) setTimeout(update,60); });
  function fail(msg,el){ err.textContent=msg; err.hidden=false; b.classList.add('is-error'); b.scrollIntoView({behavior:'smooth',block:'center'}); setTimeout(function(){ el.focus({preventScroll:true}); },250); return false; }
  function valid(){
    if(!inp.value.trim()) return fail('Please type the name for your nameplate.',inp);
    if(L==='double'&&!inp2.value.trim()) return fail('Please type the second name.',inp2);
    if(!ok.checked) return fail('Please confirm the spelling before adding to cart.',ok);
    sync(); return true;
  }
  function guard(e){
    if(!document.contains(form)){ document.removeEventListener('click',guard,true); document.removeEventListener('submit',guard,true); return; }
    var t=e.type==='submit'?e.target:(e.target.closest&&e.target.closest('button[type="submit"],[name="add"]'));
    if(!t) return; var f=e.type==='submit'?t:(t.form||t.closest('form'));
    if(f!==form) return;
    if(!valid()){ e.preventDefault(); e.stopImmediatePropagation(); }
  }
  document.addEventListener('click',guard,true);
  document.addEventListener('submit',guard,true);
  var saved=''; try{ saved=sessionStorage.getItem('gp_nameplate_name')||''; }catch(e){}
  if(saved&&L!=='initial') inp.value=clean(saved);
  update();
  if(document.fonts&&document.fonts.load) document.fonts.load('100px '+FT.fam).then(update);
}
function scan(){ document.querySelectorAll('[data-gpqa]:not([data-ready])').forEach(setup); }
new MutationObserver(scan).observe(document.documentElement,{childList:true,subtree:true});
scan();
})();
